import { useMemo } from 'react';
import { useRecentCareSources } from './useRecentCareSources';
import { buildProfileUpdateTimelineReceipts } from './profileUpdateTimelineReceiptModel';
import { useManualReviewQueueModel } from './useManualReviewQueueModel';

const useProfileUpdateTimelineReceipts = ({
  childId = '',
  viewerRole = null,
  enabled = true,
} = {}) => {
  const { error, sources } = useRecentCareSources({
    childId: enabled ? childId : '',
    includeAllMatching: true,
    notifyTimelineChanges: false,
  });
  const manualReview = useManualReviewQueueModel(sources);
  const receipts = useMemo(
    () => buildProfileUpdateTimelineReceipts(
      sources,
      viewerRole,
      manualReview.structuredDestinationsBySource
    ),
    [sources, viewerRole, manualReview.structuredDestinationsBySource]
  );

  return { error, receipts };
};

export default useProfileUpdateTimelineReceipts;
